import { faLock } from "@fortawesome/free-solid-svg-icons";
import i18n from "../../../../constants/i18n";
import getCorePersonalStore from "../../../../stores/core/core-personal-store";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3TextInput from "../../../../core/et3-input/et3-text-input";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";

const PasswordInput = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      withShadow={false}
      width={1200}
      height={255}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Et3TextInput
        size="MEDIUM"
        withShadow={true}
        type={"password"}
        icon={faLock}
        label={i18n.get("OLD_PASSWORD")}
        placeHolder={i18n.get("OLD_PASSWORD")}
        value={getCorePersonalStore().oldPassword.get()}
        onChoose={(value: string) => {
          getCorePersonalStore().oldPassword.set(value);
        }}
        onBlur={() => {}}
        onEnter={() => {}}
        style={{}}
      />
      <Et3Margin top={15} bottom={0} left={0} right={0} />
      <Et3TextInput
        size="MEDIUM"
        withShadow={true}
        type={"password"}
        icon={faLock}
        label={i18n.get("NEW_PASSWORD")}
        placeHolder={i18n.get("NEW_PASSWORD")}
        value={getCorePersonalStore().newPassword.get()}
        onChoose={(value: string) => {
          getCorePersonalStore().newPassword.set(value);
        }}
        onBlur={() => {}}
        onEnter={() => {}}
        style={{}}
      />
      <Et3Margin top={15} bottom={0} left={0} right={0} />
      <Et3TextInput
        size="MEDIUM"
        withShadow={true}
        type={"password"}
        icon={faLock}
        label={i18n.get("CONFIRM_PASSWORD")}
        placeHolder={i18n.get("CONFIRM_PASSWORD")}
        value={getCorePersonalStore().confirmPassword.get()}
        onChoose={(value: string) => {
          getCorePersonalStore().confirmPassword.set(value);
        }}
        onBlur={() => {}}
        onEnter={() => {}}
        style={{}}
      />
    </ET3Div>
  );
});
export default PasswordInput;
